export default {
  navigation: 'Navigation',
  dashboard: 'Tableau de bord',
  resources: 'Ressources',
  categories: 'Catégories',
  locations: 'Lieux',
  tags: 'Étiquettes',
  borrowings: 'Emprunts',
  consumptions: 'Consommations',
  refills: 'Réapprovisionnements',
  reservations: 'Réservations',
  profile: 'Profil',
  settings: 'Paramètres',
  admin: 'Administration',
  logout: 'Déconnexion'
};
